/**
 * Display-title helper. Platform titles arrive with clutter bolted on —
 * "Failing at Normal: An ADHD Success Story | Jessica McCabe |
 * TEDxBratislava" — and the jacket heading should carry only the real
 * title. The first separator wins; the tail keeps its separator text so
 * `head + tail` reconstructs the full title verbatim (the stage surfaces
 * render the tail in a muted tone rather than dropping it).
 */

export interface SplitTitle {
  head: string
  tail: string | null
}

// ": " (the colon must precede whitespace — protects 12:30 and URLs),
// " | ", and spaced hyphen/en/em dashes. Bare hyphens (5-4-3-2-1) never
// split.
const SEPARATOR = /:\s+|\s+\|\s+|\s+[-–—]\s+/

export function splitTitle(title: string): SplitTitle {
  const clean = title.trim()
  const match = SEPARATOR.exec(clean)
  if (!match) return { head: clean, tail: null }
  const head = clean.slice(0, match.index).trim()
  // A stub head ("Q&A: …", "Ep: …") reads worse than the clutter it saves.
  if (head.length < 4) return { head: clean, tail: null }
  return { head, tail: clean.slice(match.index) }
}
